import Vue from 'vue'
import Router from 'vue-router'

import Register from './views/Register'
import Login from './views/Login'
import ForgotPassword from './views/ForgotPassword'
import UpdatePassword from './views/UpdatePassword'
import Website from './views/Website/Layout'
import Print from './views/Print'
import WelcomeEmail from './views/WelcomeEmail'
import WebsiteIndex from './views/Website/Index'
import WebsiteTypes from './views/Website/Types'
import WebsiteRegister from './views/Website/Register'
import EventsLayout from './views/Events/Layout'
import Events from './views/Events/Index'
import EventsCreate from './views/Events/Create'
import GeneralSettings from './views/Events/Settings'
import ChangePassword from './views/Events/ChangePassword'
import Dashboard from './views/Dashboard'
import Main from './views/Main'
import Scanner from './views/Scanner'
import Users from './views/Users/Index'
import UsersInvite from './views/Users/Invite'
import UsersEdit from './views/Users/Edit'
import Attendees from './views/Attendees/Index'
import Attendee from './views/Attendees/Single'
import Speaker from './views/Speaker'
import RegistrationTypes from './views/RegistrationTypes/Index'
import RegistrationType from './views/RegistrationTypes/Single'
import RegistrationTypeGroups from './views/RegistrationTypeGroups/Index'
import RegistrationTypeGroup from './views/RegistrationTypeGroups/Single'
import Activities from './views/Activities/Index'
import Activity from './views/Activities/Single'
import ActivityAttendees from './views/Activities/Attendees'
import Checkpoints from './views/Checkpoints/Index'
import Checkpoint from './views/Checkpoints/Single'
import CustomFields from './views/CustomFields/Index'
import CustomField from './views/CustomFields/Single'
import Reports from './views/Reports'
import UserActivity from './views/UserActivity'
import MassEmailsLog from './views/MassEmailsLog.vue'
import Checkout from './views/Checkout'
import Settings from './views/Settings'
import Home from './views/Home'
import Forbidden from './views/Forbidden.vue'
import Unavailable from './views/Unavailable.vue'
import Templates from './views/Templates/Templates.vue'
// import NewTemplate from './views/Templates/TemplateForm.vue'
// import EditTemplate from './views/Templates/TemplateForm.vue'
import Uploads from './views/Uploads/Uploads.vue'
import store from './store'
import CheckpointAttendees from "./views/Checkpoints/Attendees.vue"
import CheckpointCheckin from "./views/Checkpoints/Checkin.vue"
import CheckpointPublicCheckin from "./views/Checkpoints/PublicCheckin.vue";
import Success from './views/Success.vue';
import CheckpointCustomFields from "./views/CheckpointCustomFields/Index.vue"
import CheckpointCustomFieldsForm from "./views/CheckpointCustomFields/Single.vue"
import FieldData from "./views/CheckpointCustomFields/Data.vue"

Vue.use(Router)

const permissions = {
    checkinActivities: "checkinActivities",
    checkinRegistrants: "checkinRegistrants",
    createCustomFields: "createCustomFields",
    createRegistrationTypes: "createRegistrationTypes",
    downloadReports: "downloadReports",
    editCustomFields: "editCustomFields",
    editRegistrationTypes: "editRegistrationTypes",
    editUsers: "editUsers",
    sendMassEmails: "sendMassEmails",
    settings: "settings",
    viewCustomFields: "viewCustomFields",
    viewDashboard: "viewDashboard",
    viewRegistrants: "viewRegistrants",
    viewRegistrationTypes: "viewRegistrationTypes",
    viewReports: "viewReports",
    viewUsers: "viewUsers",
    accessToTemplates: "accessToTemplates",
    createCheckpoints: "createCheckpoints",
    editCheckpoints: "editCheckpoints",
    viewAndCreateCheckinsForCheckpoints: "viewAndCreateCheckinsForCheckpoints"
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import('./views/About.vue')
        },
        {
            path: '/unavailable/:eventId?',
            name: 'unavailable',
            component: Unavailable,
            props: true
        },
        {
            path: '/forbidden/:eventId?',
            name: 'forbidden',
            component: Forbidden,
            props: true
        },
        {
            path: '/success/:eventId?',
            name: 'success',
            component: Success,
            props: true
        },
        { path: '/', name: 'home', component: Home },
        // { path: '/', name: 'login', component: Login},
        { path: '/login', name: 'login', component: Login },
        { path: '/register325', name: 'register', component: Register },
        { path: '/forgot-password', name: 'forgot-password', component: ForgotPassword },
        { path: '/update-password', name: 'update-password', component: UpdatePassword },
        { path: '/print/:registrationId', name: 'print', component: Print },
        { path: '/checkout/:registrationId?', name: 'checkout', component: Checkout },
        { path: '/welcome-email/:registrationId', name: 'welcome-email', component: WelcomeEmail },
        {
            path: '/evt/:eventId',
            component: Website,
            children: [
                { path: '/', name: 'website', component: WebsiteIndex },
                { path: 'types', name: 'website-types', component: WebsiteTypes },
                { path: 'register/:typeId/:typeName?', name: 'website-register', component: WebsiteRegister },
                { path: 'registration/:code/edit', name: 'website-registration-edit', component: WebsiteRegister },
                { 
                    path: 'checkpoints/:id', 
                    name: 'public-checkpoints-checkin', 
                    component: CheckpointPublicCheckin, 
                    props: true 
                },
            ]
        },
        {
            path: '/events',
            component: EventsLayout,
            children: [
                { path: '/', name: 'events', component: Events },
                { path: '/events/create', name: 'events-create', component: EventsCreate },
                { path: '/settings', name: 'general-settings', component: GeneralSettings },
                { path: '/change-password', name: 'change-password', component: ChangePassword }
            ]
        },
        {
            path: '/dashboard/:eventId',
            component: Dashboard,
            children: [
                {
                    path: '/',
                    name: 'dashboard',
                    component: Main, 
                    meta: {
                        permissions: [
                            permissions.viewDashboard
                        ]
                    }
                },
                {
                    path: 'templates',
                    name: 'templates',
                    component: Templates, 
                    meta: {
                        permissions: [
                            permissions.accessToTemplates
                        ]
                    }
                },
                {
                    path: 'uploads',
                    name: 'file-uploads',
                    component: Uploads, 
                    meta: {
                        permissions: [
                            "admin"
                            // permissions.accessToTemplates
                        ]
                    }
                },
                {
                    path: 'activities',
                    name: 'activities',
                    component: Activities,
                    meta: {
                        permissions: [
                            permissions.checkinActivities
                        ]
                    }
                },
                {
                    path: 'activities/create',
                    name: 'activities-create',
                    component: Activity,
                    meta: {
                        permissions: [
                            permissions.editRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'activities/:activityId/edit',
                    name: 'activities-edit',
                    component: Activity,
                    meta: {
                        permissions: [
                            permissions.editRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'activities/:activityId/attendees',
                    name: 'activity-attendees',
                    component: ActivityAttendees,
                    meta: {
                        permissions: [
                            permissions.viewRegistrants
                        ]
                    }
                },
                {
                    path: 'checkpoints',
                    name: 'checkpoints',
                    component: Checkpoints,
                    meta: {
                        permissions: [

                        ]
                    }
                },
                {
                    path: 'checkpoints/:checkpointId/attendees',
                    name: 'checkpoints-attendees',
                    component: CheckpointAttendees,
                    props: true,
                    meta: {
                        permissions: [
                            permissions.viewAndCreateCheckinsForCheckpoints
                        ]
                    }
                },
                {
                    path: 'checkpoints/:id/checkin',
                    name: 'checkpoints-checkin',
                    component: CheckpointCheckin,
                    props: true,
                    meta: {
                        permissions: [
                            permissions.viewAndCreateCheckinsForCheckpoints
                        ]
                    }
                },

                {
                    path: 'checkpoints/create',
                    name: 'checkpoints-create',
                    component: Checkpoint,
                    meta: {
                        permissions: [permissions.createCheckpoints]
                    }
                },

                {
                    path: 'checkpoints/:checkpointId/edit',
                    name: 'checkpoints-edit',
                    component: Checkpoint,
                    meta: {
                        permissions: [permissions.editCheckpoints]
                    }
                },

                {
                    path: 'speakers/create',
                    name: 'speakers-create',
                    component: Speaker,
                     meta: {
                        permissions: ['admin']
                    }
                },

                {
                    path: 'speakers/edit/:speakerId',
                    name: 'speakers-edit',
                    component: Speaker,
                     meta: {
                        permissions: ['admin']
                    }
                },

                {
                    path: 'settings', name: 'settings', component: Settings, meta: {
                        permissions: [
                            permissions.settings
                        ]
                    }
                },
                {
                    path: 'scanner/:type/:id?',
                    name: 'scanner',
                    component: Scanner,
                    meta: {
                        permissions: [
                            permissions.checkinActivities
                        ]
                    }
                },
                {
                    path: 'users',
                    name: 'users',
                    component: Users,
                    meta: {
                        permissions: [
                            permissions.viewUsers
                        ]
                    }
                },
                {
                    path: 'users/invite',
                    name: 'users-invite',
                    component: UsersInvite,
                    meta: {
                        permissions: [
                            permissions.viewUsers
                        ]
                    }
                },
                {
                    path: 'users/:userId/edit',
                    name: 'users-edit',
                    component: UsersEdit,
                    meta: {
                        permissions: [
                            permissions.viewUsers,
                            permissions.editUsers
                        ]
                    }
                },
                {
                    path: 'attendees',
                    name: 'attendees',
                    component: Attendees,
                    meta: {
                        permissions: [
                            permissions.viewRegistrants
                        ]
                    }
                },
                {
                    path: 'attendees/:registrationId',
                    name: 'attendee',
                    component: Attendee,
                    meta: {
                        permissions: [
                            permissions.viewRegistrants
                        ]
                    }
                },
                {
                    path: 'attendees/:registrationId/edit',
                    name: 'attendee-edit',
                    component: Attendee,
                    meta: {
                        permissions: [
                            permissions.viewRegistrants
                        ]
                    }
                },
                {
                    path: 'registration-types',
                    name: 'registration-types',
                    component: RegistrationTypes,
                    meta:{
                        permissions: [
                            permissions.viewRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'registration-types/create',
                    name: 'registration-types-create',
                    component: RegistrationType,
                    meta:{
                        permissions: [
                            permissions.createRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'registration-types/edit/:typeId',
                    name: 'registration-types-edit',
                    component: RegistrationType,
                    meta:{
                        permissions: [
                            permissions.editRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'registration-type-groups',
                    name: 'registration-type-groups',
                    component: RegistrationTypeGroups,
                    permissions: [
                        // permissions.viewRegistrationTypes,
                        permissions.editRegistrationTypes
                    ]
                },
                {
                    path: 'registration-type-groups/create',
                    name: 'registration-type-groups-create',
                    component: RegistrationTypeGroup,
                    permissions: [
                        // permissions.viewRegistrationTypes,
                        permissions.editRegistrationTypes
                    ]
                },
                {
                    path: 'registration-type-groups/edit/:typeGroupId',
                    name: 'registration-type-groups-edit',
                    component: RegistrationTypeGroup,
                    meta:{
                        permissions: [
                            // permissions.viewRegistrationTypes,
                            permissions.editRegistrationTypes
                        ]
                    }
                },
                {
                    path: 'custom-fields',
                    name: 'custom-fields',
                    component: CustomFields,
                    meta:{
                        permissions: [
                            permissions.viewCustomFields
                        ]
                    }
                },
                {
                    path: 'custom-fields/create',
                    name: 'custom-fields-create',
                    component: CustomField,
                    meta:{
                        permissions: [
                            permissions.viewCustomFields,
                            permissions.createCustomFields
                        ]
                    }
                },
                {
                    path: 'checkpointfields',
                    name: 'checkpointfields',
                    component: CheckpointCustomFields,
                    meta:{
                        permissions: []
                    }
                },
                {
                    path: 'checkpointfields-data',
                    name: 'checkpointfields-data',
                    component: FieldData,
                    meta:{
                        permissions: []
                    }
                },
                {
                    path: 'checkpointfields/create',
                    name: 'checkpointfields-create',
                    component: CheckpointCustomFieldsForm,
                    meta:{
                        permissions: []
                    }
                },
                {
                    path: 'checkpointfields/:fieldId/edit',
                    name: 'checkpointfields-edit',
                    component: CheckpointCustomFieldsForm,
                    props: true,
                    meta:{
                        permissions: []
                    }
                },
                {
                    path: 'custom-fields/edit/:fieldId',
                    name: 'custom-fields-edit',
                    component: CustomField,
                    meta:{
                        permissions: [
                            permissions.viewCustomFields,
                            permissions.createCustomFields,
                            permissions.editCustomFields
                        ]
                    }
                },
                {
                    path: 'user-activity',
                    name: 'user-activity',
                    component: UserActivity,
                    meta:{
                        permissions: ['admin']
                    }
                },
                {
                    path: 'mass-emails-log',
                    name: 'mass-emails-log',
                    component: MassEmailsLog,
                    meta:{
                        permissions: [permissions.sendMassEmails]
                    }
                },
                {
                    path: 'reports',
                    name: 'reports',
                    component: Reports,
                    meta:{
                        permissions: [
                            permissions.viewReports,
                        ]
                    }
                },
                {
                    path: 'registrations/:id/edit',
                    name: 'registration-edit',
                    component: WebsiteRegister,
                    meta:{
                        permissions: [
                            permissions.viewRegistrants,
                        ]
                    }
                }
            ]
        }
    ]
})


router.beforeEach(async (to, from, next) => {
    if (to.meta.permissions) {
        let user = await store.getters.getAuthenticatedUser
        if (!user.roles) {
            try {
                await store.dispatch('getUser')
            } catch (error) {
                return next('/login')
            }
        }
        user = await store.getters.getAuthenticatedUser
        if (user.admin) return next()
        const myPermissions = user.roles[to.params.eventId]
        to.meta.permissions.forEach(p => {
            if (myPermissions[p]) {
                next()
            } else {
                next(`/forbidden/${to.params.eventId}`)
            }
        })
        return next()
    }
    next()
})

export default router
